import { createAction, union } from '@ngrx/store';
import { AgreementStatuses } from 'src/app/models/agreement-statuses/agreement-statuses';
import { PrivacyPolicyAggregate } from 'src/app/models/privacy-policy/privacy-policy-aggregate';
import { TermsOfServiceAggregate } from 'src/app/models/terms-of-service/terms-of-service-aggregate';

export const storeAgreementStatuses = createAction(
  'AgreementStatusesActions storeAgreementStatuses',
  (payload: AgreementStatuses) => ({ payload }),
);

export const storePrivacyPolicy = createAction(
  'AgreementStatusesActions storePrivacyPolicy',
  (payload: PrivacyPolicyAggregate) => ({ payload }),
);

export const storeTermsOfService = createAction(
  'AgreementStatusesActions storeTermsOfService',
  (payload: TermsOfServiceAggregate) => ({ payload }),
);

const all = union({
  storeAgreementStatuses,
  storePrivacyPolicy,
  storeTermsOfService,
});

export type AgreementStatusesActionsUnion = typeof all;
